import React from 'react'

import {
  FieldPrefix,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import AddressPickerAdvanced from '../../../../../shipmetrics-shared/containers/AddressPickerAdvanced'
import AddressPickerAdvancedReadonly from '../../../../../shipmetrics-shared/containers/AddressPickerAdvanced/Readonly'

type TAddressProps = {}

const Address = (props: TAddressProps): React.ReactElement => {
  const {} = props

  const addressCanBeEdited = useField('addressCanBeEdited')
  const isLabelActivated = useField('isLabelActivated')

  return (
    <FieldPrefix prefix="pickup.address">
      {!isLabelActivated || addressCanBeEdited ? (
        <AddressPickerAdvanced withoutAddressbook hideContact />
      ) : (
        <AddressPickerAdvancedReadonly withoutAddressbook />
      )}
    </FieldPrefix>
  )
}

export default Address
